// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "92a7904ef-dirty",
    "hash": "92a7904ef",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "92a7904ef-dirty",
    "semverString": null,
    "version": "2.10.14",
    "buildNumber": 1
};
/* tslint:enable */
